import {
  DEFAULT_NODE_PADDING,
  DEFAULT_NODE_WIDTH,
  LAYOUT_MARGIN,
} from '../constants.js';
import type {
  SankeyGraphModel,
  SankeyGraphNode,
  SankeyLayoutModel,
} from '../types/sankey-internal.js';
import type { SankeyNodeAlignment } from '../types/sankey.js';
import {
  sankey,
  sankeyJustify,
  sankeyLeft,
  sankeyRight,
} from '../vendor/d3-sankey/index.js';

const alignmentMap = {
  left: sankeyLeft,
  right: sankeyRight,
  justify: sankeyJustify,
} as const;

export const generateSankeyLayout = (
  graph: SankeyGraphModel,
  width: number,
  height: number,
  nodeWidth: number = DEFAULT_NODE_WIDTH,
  nodeAlignment?: SankeyNodeAlignment,
): SankeyLayoutModel => {
  if (graph.nodes.length === 0) {
    return { nodes: [], links: [] };
  }

  const generator = sankey<SankeyGraphNode, { value: number }>()
    .nodeId((node) => node.id)
    .nodeWidth(nodeWidth)
    .nodePadding(DEFAULT_NODE_PADDING)
    .extent([
      [LAYOUT_MARGIN, LAYOUT_MARGIN],
      [width - LAYOUT_MARGIN, height - LAYOUT_MARGIN],
    ])
    .nodeAlign(alignmentMap[nodeAlignment ?? 'justify']);

  // d3-sankey mutates the objects it is given, so fresh copies of the nodes and
  // links are passed in.
  return generator({
    nodes: graph.nodes.map((node) => ({ ...node })),
    links: graph.links.map((link) => ({ ...link })),
  });
};
